import type { PillarArticle } from './types';
import { pillarArticles as en } from './en';
import { pillarArticles as pt } from './pt';
import { pillarArticles as de } from './de';

export type { PillarArticle };

export function getPillarArticles(lang: string): PillarArticle[] {
  const base = (lang || 'en').toLowerCase().split('-')[0];
  if (base === 'pt') return pt;
  if (base === 'de') return de;
  return en;
}

export function getPillarArticle(slug: string, lang: string): PillarArticle | undefined {
  return getPillarArticles(lang).find((a) => a.slug === slug);
}

export function getPillarSlugs(): string[] {
  return en.map((a) => a.slug);
}